import { render, staticRenderFns } from "./CostBearerEducationPaymentRequestPreview.vue?vue&type=template&id=0a991693"
import script from "./CostBearerEducationPaymentRequestPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerEducationPaymentRequestPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports